import { differenceInMonths, setDate, addDays, startOfDay } from 'date-fns';
import { normalize } from '@spa/shared/utils';

/*
  ATTENTION: onDatesChange is only a logical function, it doesn't store the value provided by the callback,
  {focusedInput, startDate, endDate}, so we have to store them by ourselves.
  Also to notice that focused input it's just an indicator of what input should be focused next.
*/
export const onDatesChange = (setStartDate, setEndDate, isChoosingStart, isChoosingEnd) => ({
  startDate: start,
  endDate: end,
  focusedInput: input
}) => {
  if (isChoosingEnd || end) {
    setEndDate(end, input);

    return;
  }

  if (!isChoosingStart || start) {
    setStartDate(start, input);
  }
};

/*
  The date picker hook doesn't allow to go to the month we want, only the year. So this is a hack to convert years
  in months. Using the normalize function we can get the months in year e.g 0.5 years is 6 months.
*/
export const updateActiveMonth = (action, currentActiveMonth, desiredActiveMonth, startDate, minimumGap) => {
  let newActiveMonth = desiredActiveMonth;
  if (!newActiveMonth) {
    newActiveMonth = startDate ? addDays(startDate, minimumGap) : new Date();
  }

  const activeDate = startOfDay(setDate(currentActiveMonth, 1));
  const newMonthDate = startOfDay(setDate(newActiveMonth, 1));
  const difference = differenceInMonths(newMonthDate, activeDate);
  if (Math.abs(difference) < 1) {
    return;
  }

  action(normalize(0, 12, difference));
};
